
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.594 4l-.313.281-.719.719H6v2h1v18c0 1.645 1.355 3 3 3h12c1.645 0 3-1.355 3-3V7h1V5h-6.563l-.718-.719L18.406 4zm.844 2h3.124l.72.719.312.281H23v18c0 .555-.445 1-1 1H10c-.555 0-1-.445-1-1V7h4.406l.313-.281zM11 11v11h2V11zm4 0v11h2V11zm4 0v11h2V11z"}})])
          )
        }
      }
    